// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__20iq9","card":"styles_card__3hoyi","header":"styles_header__yKdvD"};